(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kis-collection-cards"] && !Shopify.designMode) return;
  try {
    
  class KisCollectionCards extends HTMLElement {
    connectedCallback() {
      const root = this.closest('.kis-clist');
      const gap = parseInt(this.dataset.gap, 10) || 12;
      const step = () => {
        const card = this.querySelector('.kis-clist__card');
        return card ? card.offsetWidth + gap : 300;
      };
      root?.querySelector('[data-clist-prev]')?.addEventListener('click', () => this.scrollBy({ left: -step(), behavior: 'smooth' }));
      root?.querySelector('[data-clist-next]')?.addEventListener('click', () => this.scrollBy({ left: step(), behavior: 'smooth' }));

      let startX = 0;
      let startLeft = 0;
      let dragging = false;
      let moved = false;
      this.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        startX = e.clientX;
        startLeft = this.scrollLeft;
        dragging = true;
        moved = false;
        e.preventDefault();
      });
      document.addEventListener('mousemove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        if (!moved && Math.abs(dx) < 6) return;
        moved = true;
        this.scrollLeft = startLeft - dx;
        this.style.cursor = 'grabbing';
      });
      document.addEventListener('mouseup', () => {
        if (!dragging) return;
        dragging = false;
        this.style.cursor = '';
        if (moved) {
          document.addEventListener('click', function block(e) {
            e.stopPropagation();
            e.preventDefault();
          }, { capture: true, once: true });
        }
        moved = false;
      });
    }
  }
  if (!customElements.get('kis-collection-cards')) customElements.define('kis-collection-cards', KisCollectionCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kis-ig-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.kisIgReady) return;
      root.dataset.kisIgReady = '1';

      // Plaatsing zoals het live Section Store-blok: in de productinfo als het doel bestaat, anders op de plek van de sectie.
      var pos = root.getAttribute('data-position') || 'above_description';
      var target = null;
      if (pos === 'below_title' || pos === 'above_title') target = document.querySelector('.product__title');
      else if (pos === 'below_description' || pos === 'above_description') target = document.querySelector('.product__description');
      else target = document.querySelector('.product-form, .product .product-form, .shopify-payment-button, .add-to-cart');
      var inner = root.querySelector('.kis-ig-stories__inner');
      if (target && inner && !target.closest('.kis-ig-stories')) {
        var where = (pos === 'below_buy' || pos === 'below_title' || pos === 'below_description') ? 'afterend' : 'beforebegin';
        inner.classList.add('kis-ig-stories__inner--injected');
        target.insertAdjacentElement(where, inner);
      } else {
        root.classList.add('kis-ig-stories--inline');
      }
      var modal = root.querySelector('[data-kis-ig-modal]');
      if (modal && modal.parentNode !== document.body) document.body.appendChild(modal);

      var rail = inner.querySelector('[data-kis-ig-rail]');
      var wrap = inner.querySelector('.kis-ig-stories__wrap');
      var items = rail ? rail.querySelectorAll('.kis-ig-stories__item') : [];
      function checkOverflow() {
        if (!rail || !wrap) return;
        wrap.classList.toggle('has-overflow', rail.scrollWidth > rail.clientWidth + 2);
      }
      checkOverflow();
      window.addEventListener('resize', checkOverflow);
      var step = function () { return items.length ? items[0].getBoundingClientRect().width + 4 : 100; };
      var prev = inner.querySelector('[data-kis-ig-prev]');
      var next = inner.querySelector('[data-kis-ig-next]');
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });

      if (!modal) return;
      var slides = modal.querySelectorAll('[data-kis-ig-slide]');
      var current = 0;
      var muted = false;

      function stopAll() {
        slides.forEach(function (sl) {
          var v = sl.querySelector('video');
          var f = sl.querySelector('iframe');
          if (v) { v.pause(); }
          if (f) { f.removeAttribute('src'); }
        });
      }
      function show(i) {
        if (!slides.length) return;
        current = (i + slides.length) % slides.length;
        stopAll();
        slides.forEach(function (sl, idx) { sl.hidden = idx !== current; });
        var sl = slides[current];
        var v = sl.querySelector('video');
        var f = sl.querySelector('iframe');
        var muteBtn = sl.querySelector('[data-kis-ig-mute]');
        if (v) {
          v.muted = muted;
          var p = v.play();
          if (p && p.catch) {
            p.catch(function () { v.muted = true; muted = true; v.play().catch(function () {}); if (muteBtn) muteBtn.classList.remove('is-sound'); });
          }
          if (muteBtn) muteBtn.classList.toggle('is-sound', !muted);
        }
        if (f) f.src = muted ? f.getAttribute('data-src-muted') : f.getAttribute('data-src');
      }
      function open(i) {
        modal.hidden = false;
        document.body.classList.add('overflow-hidden');
        show(i);
        var closeBtn = modal.querySelector('[data-kis-ig-close]');
        if (closeBtn) closeBtn.focus();
      }
      function close() {
        stopAll();
        modal.hidden = true;
        document.body.classList.remove('overflow-hidden');
      }
      inner.querySelectorAll('[data-kis-ig-open]').forEach(function (btn) {
        btn.addEventListener('click', function () { open(parseInt(btn.getAttribute('data-kis-ig-open'), 10) || 0); });
      });
      modal.querySelectorAll('[data-kis-ig-mute]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          muted = !muted;
          var v = slides[current].querySelector('video');
          if (v) v.muted = muted;
          btn.classList.toggle('is-sound', !muted);
        });
      });
      var mprev = modal.querySelector('[data-kis-ig-modal-prev]');
      var mnext = modal.querySelector('[data-kis-ig-modal-next]');
      if (mprev) mprev.addEventListener('click', function () { show(current - 1); });
      if (mnext) mnext.addEventListener('click', function () { show(current + 1); });
      modal.querySelector('[data-kis-ig-close]').addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.classList.contains('kis-ig-stories__modal-inner')) close(); });
      document.addEventListener('keydown', function (e) {
        if (modal.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
      });
    }
    document.querySelectorAll('[data-kis-ig-stories]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-kis-ig-stories]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kis-pdp-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-kis-faq]').forEach(function (root) {
    if (root.dataset.kisFaqReady) return;
    root.dataset.kisFaqReady = '1';
    var tabs = root.querySelectorAll('[data-kis-faq-tab]');
    var panels = root.querySelectorAll('[data-kis-faq-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-kis-faq-tab');
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-kis-faq-panel') !== key;
        });
      });
    });

    root.querySelectorAll('[data-kis-faq-item]').forEach(function (item) {
      var btn = item.querySelector('.kis-pdp-faq__question');
      var toggle = function () {
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        toggle();
      });
      item.addEventListener('click', function (e) {
        if (e.target.closest('.kis-pdp-faq__question')) return;
        toggle();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kis-wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-kis-wishlist]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    var grid = root.querySelector('[data-kis-wishlist-grid]');
    var empty = root.querySelector('[data-kis-wishlist-empty]');
    var countline = root.querySelector('[data-kis-wishlist-countline]');
    var usps = root.querySelector('.kis-wishlist__usps');
    var rendered = false;

    function showEmpty() {
      grid.classList.remove('is-visible');
      if (empty) empty.hidden = false;
      if (countline) countline.hidden = true;
      if (usps) usps.hidden = true;
    }

    function updateCount(n) {
      if (!countline) return;
      if (!n) { countline.hidden = true; return; }
      var one = root.getAttribute('data-count-one') || '', many = root.getAttribute('data-count-many') || '';
      countline.textContent = n === 1 ? one : many.replace('[count]', String(n));
      countline.hidden = !countline.textContent;
    }

    function fetchCard(handle) {
      var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(sectionId);
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('[data-kis-wishlist-item]');
        })
        .catch(function () { return null; });
    }

    function render() {
      if (rendered || !window.KISWishlist) return;
      rendered = true;
      var handles = window.KISWishlist.list();
      if (!handles.length) { showEmpty(); return; }
      Promise.all(handles.map(fetchCard)).then(function (nodes) {
        var count = 0;
        nodes.forEach(function (node) { if (!node) return; grid.appendChild(node); count++; });
        if (!count) { showEmpty(); return; }
        grid.classList.add('is-visible');
        updateCount(count);
        if (window.KISWishlist.refresh) window.KISWishlist.refresh();
      });
    }

    /* Snel toevoegen: in de winkelwagenlade zoals de productpagina (Dawn cart-drawer.renderContents met secties) */
    function quickAdd(form) {
      var sel = form.querySelector('select');
      var id = sel ? sel.value : (form.querySelector('input[name="id"]') || {}).value;
      if (!id) {
        if (sel) { sel.classList.add('is-missing'); sel.focus(); window.setTimeout(function () { sel.classList.remove('is-missing'); }, 1400); }
        return;
      }
      var btn = form.querySelector('.kis-wishlist__add');
      if (!btn || btn.disabled) return;
      btn.disabled = true;
      var drawer = document.querySelector('cart-drawer');
      var body = { items: [{ id: Number(id), quantity: 1 }] };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json.status) throw new Error(json.description || 'fout');
          if (drawer && typeof drawer.renderContents === 'function') {
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            drawer.renderContents(json);
          }
          if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'kis-wishlist', productVariantId: id, cartData: json });
          var t = form.querySelector('.kis-wishlist__add-text'), d = form.querySelector('.kis-wishlist__add-done');
          btn.classList.add('is-done'); if (t) t.hidden = true; if (d) d.hidden = false;
          window.setTimeout(function () { btn.classList.remove('is-done'); if (t) t.hidden = false; if (d) d.hidden = true; }, 2200);
        })
        .catch(function (e) { console.error('[KIS verlanglijst] toevoegen mislukt', e); })
        .then(function () { btn.disabled = false; });
    }

    root.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-kis-wishlist-quick]');
      if (!form) return;
      event.preventDefault();
      quickAdd(form);
    });

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-kis-wishlist-remove]');
      if (!btn) return;
      event.preventDefault();
      var handle = btn.getAttribute('data-kis-wishlist-remove');
      var item = btn.closest('[data-kis-wishlist-item]');
      if (item) item.remove();
      if (window.KISWishlist) window.KISWishlist.remove(handle);
      var left = grid.querySelectorAll('[data-kis-wishlist-item]').length;
      if (!left) showEmpty(); else updateCount(left);
    });

    document.addEventListener('kis:wishlist:change', function (event) {
      var handles = (event.detail && event.detail.handles) || [];
      grid.querySelectorAll('[data-kis-wishlist-item]').forEach(function (item) {
        if (handles.indexOf(item.getAttribute('data-kis-wishlist-item')) === -1) item.remove();
      });
      var left = grid.querySelectorAll('[data-kis-wishlist-item]').length;
      if (rendered && !left) showEmpty(); else if (rendered) updateCount(left);
    });

    if (window.KISWishlist) render();
    else {
      document.addEventListener('kis:wishlist:ready', render, { once: true });
      var tries = 0;
      var wait = function () {
        if (window.KISWishlist) { render(); return; }
        if (tries++ < 100) window.setTimeout(wait, 50);
        else showEmpty();
      };
      wait();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
